import { render, staticRenderFns } from "./oilProduct.vue?vue&type=template&id=40f4b8ac&"
import script from "./oilProduct.vue?vue&type=script&lang=js&"
export * from "./oilProduct.vue?vue&type=script&lang=js&"
import style0 from "./oilProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports